import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import CoupounForm, { CoupounFormData } from "../../../components/admin/coupouns/CoupounForm";

export default function AdminAddCoupounPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } ,watch} = useForm<CoupounFormData>({
  });


   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: CoupounFormData) => {
    if(data.startDate){
      data.startDate = new Date(data.startDate).toISOString()
    }
    if(data.expiryDate){
      data.expiryDate = new Date(data.expiryDate).toISOString()
    }
    updateResource(`coupon`, {...data},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["coupons-by-admin"],
            navigateAfter: () => navigate(`/admin/coupouns`),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_gift_category" />
        <CoupounForm register={register} errors={errors} watch={watch}/>
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}